import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import ApproveFiveForm from "./dynamic-form/ApproveFiveForm";
import ApproveFiveElement from "./dynamic-report/ApproveFiveElement";

class ReportApproveFive extends Component {
  // ----------------------
  // Computed
  // ----------------------

  get showReviewed() {
    return this.props.report.approvedFiveAt;
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <Fragment>
        {this.props.report.getCanApproveFive(this.props.userContext.scope) &&
        <ApproveFiveForm reportGuid={this.props.report.guid}/>
        }
        {this.showReviewed &&
        <ApproveFiveElement
          approvedFiveAt={this.props.report.approvedFiveAt}
          approvedFiveBy={this.props.report.getFullNameFor('approverFive')}
          approveCommentFive={this.props.report.approveCommentFive}
        />
        }
      </Fragment>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    userContext: state.common.userContext,
  };
};

export default connect(mapStateToProps, null)(ReportApproveFive);
